<div id="inner-create-container" class="create-page container-fluid pb-6">
  <div class="h-100 container">
    <div class="h-100 justify-content-center align-items-center row">
      <div class="col-lg-6">
        <div class="card">
          <div class="p-4">
            <h4 class="card-title">Admin Login</h4>
            <!-- Forms Section -->
            <form [formGroup]="loginForm" (ngSubmit)="login()">
              <!-- Email -->
              <div class="form-group col-md-12 pb-2">
                <label for="email" class="required">E-mail Address </label>
                <input formControlName="email" maxlength="250" type="email" class="form-control mt-2" id="email"
                  placeholder="Enter Email Address" required />
              </div>
              <!-- Password -->
              <div class="form-group col-md-12 pb-2">
                <label for="password" class="required">Password</label>

                <div class="input-group">
                  <input formControlName="password" [type]="showPassword ? 'text' : 'password'" class="form-control"
                    id="password" placeholder="Enter Password" required />
                  <div class="input-group-append" (click)="togglePassword()">
                    <span class="input-group-text h-100"> <fa-icon
                        [icon]="showPassword ? faEye : faEyeSlash"></fa-icon></span>
                  </div>
                </div>

              </div>
              <div class="row mt-3">
                <div id="action-group" class="d-flex flex-col align-items-center">
                  <button type="submit" class="btn btn-primary" [disabled]="!loginForm.valid">
                    Login
                  </button>
                  <div>
                    <u class="forgotPass"><a [routerLink]="['/forgot-password']">Forgot Password?</a></u>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>